
















































































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import PersonAutoComplete from "@/components/PersonAutoComplete.vue";
import { storeCodeBlueActivation } from "@/store/modules/CodeBlueActivationStore";
import CodeBlueActivationSvc from "@/services/CodeBlueActivation";
import { storePasien } from "@/store/modules/pasien";
import { userModule } from "@/store/modules/user";
import { alasanTtdMengunciHapus, slotTandaTanganDokumen } from "@/utils/hapusSetelahTtd";

@Component({
  components: {
    CardModalTtd,
    PersonAutoComplete
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardCodeBlueActivation extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get canCreate(): boolean {
    if (this.readOnly) return false;
    return userModule.canAccessForm("code_blue_activation", "create");
  }

  get canEditForm(): boolean {
    if (this.readOnly) return false;
    return userModule.canAccessForm("code_blue_activation", "edit");
  }

  showForm = false;
  showDetail = false;
  isEditing = false;
  editingId: number | null = null;
  saving = false;
  formValid = false;
  dateMenu = false;
  detailData: any = null;
  modalTtd = false;
  signRole: "dokter" | "perawat" = "dokter";

  form: any = this.getEmptyForm();

  headers = [
    { text: "No", value: "no", width: "5%", sortable: false },
    { text: "Tanggal", value: "tanggal", width: "15%" },
    { text: "Waktu", value: "waktu", width: "10%" },
    { text: "Lokasi", value: "lokasi", width: "25%" },
    { text: "Status", value: "status", width: "15%" },
    { text: "Aksi", value: "aksi", sortable: false, width: "30%" }
  ];

  get loading() { return storeCodeBlueActivation.loading; }
  get stateList() { return storeCodeBlueActivation.list; }

  getEmptyForm() {
    return {
      register_id: null,
      pasien_rm: null,
      tanggal: null,
      waktu_mulai: null,
      lokasi: null,
      sistem_kode_biru_aktif: false,
      tipe: null,
      respirasi: false,
      pasien_serangan: null,
      initial_airway: null,
      ventilasi_manual: false,
      ventilasi_ett: false,
      ventilasi_tracheostomy: false,
      ventilasi_lma: false,
      jenis_ventilasi: null,
      waktu_intubasi: null,
      bag_tube_size: null,
      intubasi_oleh: null,
      nadi_teraba: null,
      irama_nadi: null,
      waktu_mulai_rjp: null,
      irama_jantung_mulai_rjp: null,
      waktu_mulai_pasang_infus: null,
      lokasi_iv: null,
      tidak_ada_iv_cath: false,
      monitoring_terapi: [],
      resusitasi_berhasil: null,
      sirkulasi_kembali: false,
      pernafasan_kembali: false,
      tidak_ada_respon: false,
      keluarga_pasien: null,
      kode_dokter_biru: null,
      pasien_dikirim_igd: null,
      perawat_pelaksana: null,
      perawat_dokumentasi: null,
      pasien_dikirim_ruang_perawatan: null,
      identitas_nama: null,
      identitas_umur: null,
      identitas_jenis_kelamin: null,
      identitas_alamat: null,
      catatan_perawat: null,
    };
  }

  getEmptyMonitoringRow() {
    return {
      waktu: null,
      pernafasan: null,
      tekanan_darah: null,
      nadi_irama: null,
      defibrilation: null,
      pacemaker: null,
      epinephrine: null,
      atropine: null,
      amiodarone: null,
      lidocain: null,
      vasopressin: null,
      sulfate_magnesium: null,
      adenocard: null,
      dopamin: null,
      catatan_perawat: null,
    };
  }

  addMonitoringRow() {
    this.form.monitoring_terapi.push(this.getEmptyMonitoringRow());
  }

  removeMonitoringRow(idx: number) {
    this.form.monitoring_terapi.splice(idx, 1);
  }

  getStatusColor(item: any) {
    if (item.status === "selesai") return "green";
    if (item.status === "sebagian") return "orange";
    return "grey";
  }

  getStatusLabel(item: any) {
    if (item.status === "selesai") return "Selesai";
    if (item.status === "sebagian") return "Sebagian TTD";
    return "Draft";
  }

  getVentilasiLabel(item: any) {
    const labels: string[] = [];
    if (item.ventilasi_manual) labels.push("Manual ventilasi");
    if (item.ventilasi_ett) labels.push("ETT");
    if (item.ventilasi_tracheostomy) labels.push("Tracheostomy");
    if (item.ventilasi_lma) labels.push("LMA");
    return labels.length ? labels.join(", ") : "-";
  }

  openForm() {
    this.form = this.getEmptyForm();
    this.form.monitoring_terapi = [this.getEmptyMonitoringRow()];
    this.isEditing = false;
    this.editingId = null;

    // Auto-prefill identitas from patient data
    const pasien = storePasien.identitasPasien;
    if (pasien) {
      this.form.identitas_nama = pasien.nama || null;
      this.form.identitas_umur = pasien.usia || null;
      this.form.identitas_alamat = pasien.alamat || null;

      // jk bisa "Laki-laki"/"Perempuan" atau "L"/"P"
      const jk = pasien.jk;
      if (jk === "Laki-laki" || jk === "L") {
        this.form.identitas_jenis_kelamin = "Laki-laki";
      } else if (jk === "Perempuan" || jk === "P") {
        this.form.identitas_jenis_kelamin = "Perempuan";
      }
    }

    this.showForm = true;
  }

  openEdit(item: any) {
    this.form = { ...item };
    if (!this.form.monitoring_terapi || !Array.isArray(this.form.monitoring_terapi)) {
      this.form.monitoring_terapi = [this.getEmptyMonitoringRow()];
    }
    this.isEditing = true;
    this.editingId = item.id;
    this.showForm = true;
  }

  async openDetail(item: any) {
    try {
      const resp = await CodeBlueActivationSvc.find(item.id);
      this.detailData = resp.data.data;
      this.showDetail = true;
    } catch {
      // Error handled by service
    }
  }

  closeForm() {
    this.showForm = false;
    this.form = this.getEmptyForm();
  }

  async simpan() {
    if (!(this.$refs.formRef as any).validate()) return;

    this.saving = true;
    try {
      if (this.isEditing && this.editingId) {
        await CodeBlueActivationSvc.update(this.editingId, this.form);
      } else {
        this.form.register_id = this.register;
        this.form.pasien_rm = this.rm;
        await CodeBlueActivationSvc.create(this.form);
      }
      await storeCodeBlueActivation.getByRegister(this.register);
      this.closeForm();
      this.$emit("saved");
    } catch {
      // Error handled by service
    }
    this.saving = false;
  }

  alasanTidakBisaHapus(item: any): string {
    if (this.readOnly) return "Rekam medis sudah terkunci (read-only)";
    return alasanTtdMengunciHapus(
      item.user_id,
      [
        ...slotTandaTanganDokumen(item.signed_dokter, item.signature_dokter),
        ...slotTandaTanganDokumen(item.signed_perawat, item.signature_perawat)
      ],
      userModule.user?.id
    );
  }

  async remove(item: any) {
    if (this.alasanTidakBisaHapus(item)) return;
    if (!confirm("Apakah Anda yakin ingin menghapus data ini?")) return;
    try {
      await CodeBlueActivationSvc.destroy(item.id);
      await storeCodeBlueActivation.getByRegister(this.register);
    } catch {
      // Error handled by service
    }
  }

  cetakPdf(item: any) {
    CodeBlueActivationSvc.print(item.id);
  }

  openTtd(role: "dokter" | "perawat") {
    this.signRole = role;
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    this.modalTtd = false;
    if (!this.detailData) return;

    try {
      if (this.signRole === "dokter") {
        await CodeBlueActivationSvc.signDokter(this.detailData.id, { password });
      } else {
        await CodeBlueActivationSvc.signPerawat(this.detailData.id, { password });
      }
      // Refresh detail and list
      const resp = await CodeBlueActivationSvc.find(this.detailData.id);
      this.detailData = resp.data.data;
      await storeCodeBlueActivation.getByRegister(this.register);
    } catch {
      // Error handled by service
    }
  }
}
